import styled from "styled-components";
import { theme } from "../../../../helpers/theme";


export const Container = styled.section`
  font-family: ${theme.fonts.interMedium};
  width: 100%;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${theme.device.laptop} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 100px;
  }

  @media ${theme.device.Mtablet} {
    margin-bottom: 30px;
  }
`;

export const MpImg = styled.img`
width: 250px;
height: 250px;
margin-bottom: 50px;
margin-top: 20px;

  @media ${theme.device.mobileL} {
    width: 300px;
    height: 300px;
  }
  
  @media ${theme.device.tablet} {
    width: 400px;
    height: 400px;
  }

  @media ${theme.device.laptopL} {
    width: 520px;
    height: 520px;
  }
`;